<div class="flex min-h-screen flex-col">
  @if (showChrome()) {
    <header class="bg-white">
      <div class="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <img src="/images/fertiflow-logo.png" alt="FertiFlow" class="h-[26px] w-auto" />
        <app-user-menu />
      </div>
    </header>
  }

  <main class="flex-1">
    <router-outlet />
  </main>
  @if (showChrome()) {
    <footer class="border-t border-gray-200 px-4 py-3 text-center text-xs text-gray-500">
      {{ 'shell.footer.copyright' | transloco }}
    </footer>
  }
</div>
